module.exports = __webpack_public_path__ + "static/media/r190.06bf7aaa.jpg";